import { HttpClient } from '../http-client';

// TODO: type the returns properly
class UserHttpClient extends HttpClient {
  public async triggerResetPasswordEmail(email: string): Promise<any> {
    return this.post('/users/forgot', {
      emailId: email,
    });
  }
  public async getDetailsFromToken(token: string): Promise<any> {
    return this.post(`/users/auth?token=${token}`);
  }
  public async resetPassword(payload: {
    newPassword: string;
    confirmPassword: string;
    token: string;
  }): Promise<{ sessionToken: string }> {
    // TODO: Remove the duplicate token param sending once api fixes it.
    return this.put(`/users/reset?token=${payload.token}`, payload);
  }
}
export const UserAPI = new UserHttpClient();
